import { render, staticRenderFns } from "./BlogFooter.vue?vue&type=template&id=fd7d9f4a&scoped=true"
import script from "./BlogFooter.vue?vue&type=script&lang=js"
export * from "./BlogFooter.vue?vue&type=script&lang=js"
import style0 from "./BlogFooter.vue?vue&type=style&index=0&id=fd7d9f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7d9f4a",
  null
  
)

export default component.exports